const wordpressBlocks = (): void => {
  // Apply download icon to buttons linking to files
  const downloadExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.zip', '.rar'];
  const downloadButtons = document.querySelectorAll('.wp-block-button');

  downloadButtons.forEach((button) => {
    const link = button.querySelector('a');
    if (link) {
      const href = link.getAttribute('href') || '';
      const hasDownloadAttr = link.hasAttribute('download');
      const isDownloadLink = downloadExtensions.some(ext => href.toLowerCase().endsWith(ext));

      // Add download style if link points to a file or has download attribute
      if (isDownloadLink || hasDownloadAttr) {
        button.classList.add('is-style-download');
      }
    }
  });

  const selectors = {
    wpVideoWrapper: '.wp-block-video',
    video: 'video',
  };

  const classes = {
    wpVideoWrapperPlaying: 'wp-block-video--playing',
    wpVideoWrapperPaused: 'wp-block-video--paused',
  };

  const videoWrappers = document.querySelectorAll(selectors.wpVideoWrapper);

  if (videoWrappers) {
    videoWrappers.forEach((videoWrapper) => {
      const video = videoWrapper.querySelector<HTMLVideoElement>(
        selectors.video
      );

      if (video) {
        // If not set to autoplay
        if (video.paused) {
          video.removeAttribute('controls');
          videoWrapper.classList.add(classes.wpVideoWrapperPaused);

          videoWrapper.addEventListener('click', () => {
            if (
              videoWrapper.classList.contains(classes.wpVideoWrapperPlaying)
            ) {
              setTimeout(() => {
                video.pause();
              }, 100);
            } else {
              setTimeout(() => {
                video.play();
              }, 100);
            }
          });
        }

        video.addEventListener('play', () => {
          video.setAttribute('controls', '');
          videoWrapper.classList.add(classes.wpVideoWrapperPlaying);
          videoWrapper.classList.remove(classes.wpVideoWrapperPaused);
        });

        video.addEventListener('pause', () => {
          video.removeAttribute('controls');
          videoWrapper.classList.remove(classes.wpVideoWrapperPlaying);
          videoWrapper.classList.add(classes.wpVideoWrapperPaused);
        });
      }
    });
  }
};

export default wordpressBlocks;
